import {
  mapVenueOverviewVersionType,
  PermissionNameUnionType,
  useFindVenueOverviewVersionSuspense,
} from '@api';
import {
  EditActionIcon,
  TouringCard,
  TouringCardActions,
  TouringCardHeader,
  TouringCardSection,
  TouringCardTitle,
} from '@common';
import { usePermissionContext } from '@hypeit-gmbh/hypeit-ui-core';
import { Modal } from '@mantine/core';
import { useDisclosure } from '@mantine/hooks';
import { useTranslation } from 'react-i18next';
import { Route } from 'src/routes/_rootLayout/venues/$id.overview.$version';
import { VenueSuitesForm, VenueSuitesTable } from './components';

export const VenueSuites: React.FC = () => {
  const { t } = useTranslation('venueDetailsOverview');
  const [opened, { open: openModal, close: closeModal }] = useDisclosure(false);
  const { id, version } = Route.useParams();
  const { hasPermission } = usePermissionContext<PermissionNameUnionType>();
  const { data: overviewVersion } = useFindVenueOverviewVersionSuspense(
    id,
    version,
    {
      query: {
        select: (data) => mapVenueOverviewVersionType(data.data),
      },
    }
  );

  const userCanEditVenueSuites = hasPermission({
    permission: 'VENUES_OVERVIEW',
    action: 'WRITE',
  });

  return (
    <>
      <TouringCard data-testid="venue-suites">
        <TouringCardHeader>
          <TouringCardTitle>{t('VENUE_SUITES.TITLE')}</TouringCardTitle>
          {userCanEditVenueSuites && (
            <TouringCardActions>
              <EditActionIcon onClick={openModal} />
            </TouringCardActions>
          )}
        </TouringCardHeader>
        <TouringCardSection>
          <VenueSuitesTable venueSuites={overviewVersion.suites} />
        </TouringCardSection>
      </TouringCard>
      <Modal
        opened={opened}
        onClose={closeModal}
        title={t('VENUE_SUITES.EDIT_MODAL_TITLE')}
      >
        <VenueSuitesForm
          venueId={id}
          overviewVersion={version}
          venueSuites={overviewVersion.suites}
          onClose={closeModal}
        />
      </Modal>
    </>
  );
};
